import { PaletteTheme } from '@kite-js/theme-types';
import colors from '../colors';

type SystemPalette = Pick<PaletteTheme, 'success' | 'warning' | 'error' | 'notice'>;

const systemPalette: SystemPalette = {
    success: {
        darkSolid: {
            background: colors.green[500],
            text: colors.white,
        },
        solid: {
            background: colors.green[300],
            text: colors.white,
        },
        light: {
            background: colors.green[50],
            text: colors.green[500],
        },
        bordered: {
            background: colors.white,
            border: colors.green[300],
            text: colors.green[300],
        },
        plainText: {
            text: colors.green[300],
        },
        gradient: {
            backgroundStart: colors.green[300],
            backgroundEnd: colors.green[300],
            text: colors.white,
        },
    },
    warning: {
        darkSolid: {
            background: colors.red[500],
            text: colors.white,
        },
        solid: {
            background: colors.red[300],
            text: colors.white,
        },
        light: {
            background: colors.red[50],
            text: colors.red[500],
        },
        bordered: {
            background: colors.white,
            border: colors.red[300],
            text: colors.red[300],
        },
        plainText: {
            text: colors.red[300],
        },
        gradient: {
            backgroundStart: colors.red[300],
            backgroundEnd: colors.red[500],
            text: colors.white,
        },
    },
    error: {
        darkSolid: {
            background: colors.red[500],
            text: colors.white,
        },
        solid: {
            background: colors.red[300],
            text: colors.white,
        },
        light: {
            background: colors.red[50],
            text: colors.red[500],
        },
        bordered: {
            background: colors.white,
            border: colors.red[100],
            text: colors.red[300],
        },
        plainText: {
            text: colors.red[300],
        },
        gradient: {
            backgroundStart: colors.red[300],
            backgroundEnd: colors.red[500],
            text: colors.white,
        },
    },
    notice: {
        darkSolid: {
            background: colors.background[800],
            text: colors.white,
        },
        solid: {
            background: colors.background[200],
            text: colors.white,
        },
        light: {
            background: colors.blue[50],
            text: colors.blue[300],
        },
        bordered: {
            background: colors.white,
            border: colors.blue[300],
            text: colors.blue[300],
        },
        plainText: {
            text: colors.blue[300],
        },
        gradient: {
            backgroundStart: colors.background[800],
            backgroundEnd: colors.background[800],
            text: colors.white,
        },
    },
};

export default systemPalette;
